import { render } from "./MyOrganizationsPage.vue?vue&type=template&id=d4b02de4&scoped=true"
import script from "./MyOrganizationsPage.vue?vue&type=script&lang=js"
export * from "./MyOrganizationsPage.vue?vue&type=script&lang=js"

import "./MyOrganizationsPage.vue?vue&type=style&index=0&id=d4b02de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b02de4"]])

export default __exports__